import { Chart } from 'react-google-charts';

import { useData } from '../../utils/hooks/useData';
import { useMergedData } from '../../utils/hooks/useMergedData';
import { useAnalyticsStoreContext } from '../contexts';

import AnalyticsError from '../AnalyticsError';
import { formatFromAndToQuery, getChartOptions } from '../lib';

export default function RecentTraffic({ endpoints }) {
  const { recent_traffic_api_v1_cms_analytics_path } = endpoints;

  const dateRange = useAnalyticsStoreContext((state) => state.data.first.dateRange);
  const dateRangeTwo = useAnalyticsStoreContext((state) => state.data.second.dateRange);
  const isComparing = useAnalyticsStoreContext((state) => state.isComparing);

  const { data, isLoading, error } = useData(`${recent_traffic_api_v1_cms_analytics_path}.json?${formatFromAndToQuery(dateRange)}`);

  const {
    data: dataTwo,
    isLoading: isLoadingTwo,
    error: errorTwo,
  } = useData(
    `${recent_traffic_api_v1_cms_analytics_path}.json?${formatFromAndToQuery(dateRangeTwo)}`,
    isComparing && dateRangeTwo.from && dateRangeTwo.to,
    [],
  );

  const chartData = useMergedData(data, dataTwo, isComparing, null, { merge: true });

  return (
    <div className="card card-fill">
      <div className="card-header">Website Traffic - Total Users</div>
      <div className="card-body">
        {isLoading || isLoadingTwo ? (
          <div className="d-flex align-items-center justify-content-center" style={{ height: 200 }}>
            <div className="spinner-border" role="loading">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : error || errorTwo ? (
          <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: 200 }}>
            {error && (
              <div className="d-flex gap-2">
                <span>First Dataset:</span>
                <AnalyticsError errorMsg={error} />
              </div>
            )}
            {errorTwo && (
              <div className="d-flex gap-2">
                <span>Second Dataset:</span>
                <AnalyticsError errorMsg={errorTwo} />
              </div>
            )}
          </div>
        ) : (
          <Chart width="100%" height={200} chartType="LineChart" legendToggle data={chartData} options={getChartOptions('traffic', dateRange)} />
        )}
      </div>
    </div>
  );
}
